<template>
  <div>
    <v-btn v-if="$isUserRoleGreaterThan('sales_associate_back')" variant="text" rounded="0" color="primary"
      class="admin-button pt-1" to="/admin"> <span class="mt-1 mr-2">Admin</span>
      <v-icon>mdi-account-cog</v-icon>
    </v-btn>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<style>
:root {
  --v-theme-primary: 242, 124, 56;

}

/*TODO: mettre au bon endroit ? */
.v-theme--myQuoteTheme {
  --v-disabled-opacity: 0.7 !important;
}

.v-field--variant-outlined .v-field__outline__start {
  border-radius: 4px 0 0 4px;
}

.v-field--variant-outlined .v-field__outline__end {
  border-radius: 0 4px 4px 0;
}

.v-field__outline__end {
  border-radius: 0 4px 4px 0 !important;
}

.v-data-table td{
  word-break: break-word;
}


.mobile {
  max-width: 400px;
  border: 1px solid #ccc;
  min-height: 100vh;
  margin: 0 auto;
}

::before,
::after {

  text-decoration: inherit;
  vertical-align: inherit;

}

@media (min-width: 960px) and (max-width: 1280px) {
  .v-container {
    max-width: none;
  }

}


.admin-button {
  display: none;
  text-transform: none !important;
}

@media (min-width: 1024px) {
  .admin-button {
    display: block;
    position: fixed;
    top: 10px;
    right: 10px;
  }
}
</style>